import dynamicRegister from './dynamicRegister.service'
import dynamicForm from './dynamicForm.service'
import appSettings from './appSettings.service'
import participant from './participant.service'

export default {
    dynamicRegister: dynamicRegister,
    dynamicForm: dynamicForm,
    appSettings: appSettings,
    participant: participant
}
